import {
  GETMANUALUPGRADEKYCLIST_SUCCESS,
  GETMANUALUPGRADEKYCLIST_FAILED,
  RESET_GETMANUALUPGRADEKYCLIST,
  LOADING_GETMANUALUPGRADEKYCLIST,
  NETWORK_ERROR_GETMANUALUPGRADEKYCLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetManualUpgradeKycList = () => {
  return { type: RESET_GETMANUALUPGRADEKYCLIST };
};

const getManualUpgradeKycList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETMANUALUPGRADEKYCLIST });
  await partnerServices
    .post("getManualUpgradeKycList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getManualUpgradeKycListsuccess(res.data));
          break;
        default:
          dispatch(getManualUpgradeKycListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETMANUALUPGRADEKYCLIST,
        payload: err,
      });
    });
};
function getManualUpgradeKycListsuccess(data) {
  return {
    type: GETMANUALUPGRADEKYCLIST_SUCCESS,
    payload: data,
  };
}
function getManualUpgradeKycListFailed(data) {
  return {
    type: GETMANUALUPGRADEKYCLIST_FAILED,
    payload: data,
  };
}

export { getManualUpgradeKycList, resetGetManualUpgradeKycList };
